import { Anchor, CenterContainer, SideContainer } from './PoweredBy.styles';
import { Fragment, FunctionalComponent, h } from 'preact';
import { isPrivacyButtonUI } from '@usercentrics/cmp-browser-sdk';
import { useSettingsContext } from '../../contexts/SettingsContext';

type Props = {
  sidePosition?: boolean;
};

const PoweredBy: FunctionalComponent<Props> = ({ sidePosition = false }) => {
  const { labels, ui } = useSettingsContext();

  if (!labels || !ui || isPrivacyButtonUI(ui) || !ui.poweredBy) {
    return null;
  }

  const { url, partnerUrl } = ui.poweredBy;
  const { label, partnerUrlLabel, urlLabel } = labels.poweredBy;

  const standardPoweredBy = url ? (
    <Anchor href={url} target="_blank" rel="noopener">
      {urlLabel}
    </Anchor>
  ) : (
    urlLabel
  );

  const partnerPoweredBy = partnerUrl ? (
    <Anchor href={partnerUrl} target="_blank" rel="noopener">
      {partnerUrlLabel}
    </Anchor>
  ) : (
    partnerUrlLabel
  );

  const content = (
    <Fragment>
      {label}
      {String.fromCharCode(160)}
      {urlLabel && standardPoweredBy}
      {urlLabel && partnerUrlLabel && (
        <Fragment>
          {String.fromCharCode(160)}
          &amp;
          {String.fromCharCode(160)}
        </Fragment>
      )}
      {partnerUrlLabel && partnerPoweredBy}
    </Fragment>
  );

  return (
    <Fragment>
      {sidePosition ? <SideContainer>{content}</SideContainer> : <CenterContainer>{content}</CenterContainer>}
    </Fragment>
  );
};

export default PoweredBy;
